import { Link as RouterLink } from 'react-router-dom'
import styled from '@emotion/styled'

import { createTheme } from './mixins'
import { THEMES } from './themes'

export const Link = styled.a`
  text-decoration: none;

  ${({ theme }) => {
    const linkTheme = THEMES[theme]
    return createTheme(linkTheme)
  }}
`

Link.defaultProps = {
  theme: 'primary',
  as: RouterLink,
}
